module.exports = __webpack_public_path__ + "img/jp-04.c0166afd.png";